import { render, staticRenderFns } from "./InsectV2View.vue?vue&type=template&id=57d69dd7&scoped=true&"
import script from "./InsectV2View.vue?vue&type=script&lang=js&"
export * from "./InsectV2View.vue?vue&type=script&lang=js&"
import style0 from "./InsectV2View.vue?vue&type=style&index=0&id=57d69dd7&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d69dd7",
  null
  
)

/* custom blocks */
import block0 from "./InsectV2View.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d69dd7')) {
      api.createRecord('57d69dd7', component.options)
    } else {
      api.reload('57d69dd7', component.options)
    }
    module.hot.accept("./InsectV2View.vue?vue&type=template&id=57d69dd7&scoped=true&", function () {
      api.rerender('57d69dd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/InsectV2View/InsectV2View.vue"
export default component.exports